// extracted by mini-css-extract-plugin
module.exports = {"btnBack":"BtnBack_btnBack__ldhUY"};